import React, { useEffect, useState } from 'react'

import { getApiErrorMessage, showErrorModal, unmountConfirmation } from '@/utils/confirmations'
import { t } from '@/utils/i18n'
import ReactDOM from 'react-dom'

import { Select } from './Forms/Fields'
import Modal from './Modal'

export const ConfirmationWithDataTransfer = ({
  title,
  description,
  options,
  transferTitle,
  onConfirm,
  onClose,
  renderOptionLabel,
  formatSelectedItem,
  ...others
}) => {
  const [value, setValue] = useState(options[0])

  const onConfirmationConfirm = () => {
    onConfirm(value.id)
      .then(() => Turbo.visit(window.location))
      .catch(() => {
        showErrorModal({
          title: getApiErrorMessage(null)
        })
      })
  }

  return ReactDOM.createPortal(
    <Confirmation cancelAction={onClose} className='transfer-modal' onConfirm={onConfirmationConfirm} {...others}>
      <>
        <div className='transfer-modal__info'>
          <div className='title'>{title}</div>
          <div className='description'>{description}</div>
        </div>
        <div className='transfer-modal__transfer'>
          <div className='description'>{transferTitle}</div>
          <div className='select'>
            <Select
              name='transfer_select'
              items={options}
              value={value}
              renderOptionLabel={renderOptionLabel}
              formatSelectedItem={formatSelectedItem}
              onSelect={setValue}
            />
          </div>
        </div>
      </>
    </Confirmation>,
    document.querySelector('.confirmation-container')
  )
}

const Confirmation = ({
  setIsOpen,
  event,
  cancelAction,
  onConfirm,
  closeOnConfirm,
  confirmButton,
  text,
  children,
  className = '',
  autoFocus = false,
  cancelText = t('cancel')
}) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (event) {
      event.stopPropagation()
      event.preventDefault()
    }

    setLoading(false)
  }, [event])

  const close = event => {
    if (event) {
      event.preventDefault()
      event.nativeEvent.stopImmediatePropagation()
    }

    if (cancelAction) {
      cancelAction()
    }

    if (setIsOpen) {
      setIsOpen(false)
    } else {
      unmountConfirmation()
    }
  }

  const confirmAction = () => {
    setLoading(true)

    if (onConfirm) {
      onConfirm()
    } else {
      event.target.dispatchEvent(new MouseEvent('click', { bubbles: true, confirmed: true }))
    }

    if (closeOnConfirm) close()
  }

  const buttons = [
    {
      title: cancelText,
      type: 'secondary',
      onClick: close
    }
  ]

  if (confirmButton)
    buttons.unshift({
      ...confirmButton,
      onClick: confirmAction,
      disabled: loading
    })

  if (autoFocus) buttons[0].autoFocus = true

  return (
    <Modal
      isOpen
      className={`modal-dialog-centered confirmation-modal ${className}`}
      buttons={buttons}
      buttonPlacement='center'
      onClose={close}
    >
      {text}
      {children}
    </Modal>
  )
}

export default Confirmation
